var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../components/score';
import { t } from 'i18next';
import { formatDate } from '../../utils/date';
import { BaseComponent } from '../../utils/BaseComponent';
import { isEmpty } from '../../utils/stringUtils';
import './TrustTransactionBadge';
import { getRole } from './getRole';
let PublicFeedback = class PublicFeedback extends BaseComponent {
    constructor() {
        super(...arguments);
        this.noShadows = false;
        this.showReplies = false;
        this.showTransactionalBadge = false;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        var _a, _b, _c, _d, _e;
        const hasTextFeedback = !isEmpty(this.participant.feedback.textReview);
        return html `
      <li>
        <div class='p-16 bg-surface-primary rounded-lg h-full ${this.noShadows ? '' : 'drop-shadow-md'}'>
          <div class='flex justify-between font-normal'>
            <div class='flex leading-20'>
              <trust-score score='${this.participant.feedback.score}'></trust-score>
              <div>
                ${this.profileUrl ? html `
                  <a class='text-link font-medium no-underline hover:brightness-75 hover:underline' href='${this.profileUrl}'>${(_a = this.participant.name) !== null && _a !== void 0 ? _a : t('Anonymous user')}</a>
                ` : html `
                  <p class='strong'>${(_b = this.participant.name) !== null && _b !== void 0 ? _b : t('Anonymous user')}</p>
                `}
                <p class='detail'>
                  ${t(getRole(this.participant))}
                </p>
              </div>
            </div>
            <span>
              ${formatDate(this.participant.feedback.givenAt)}
            </span>
          </div>
          <p class='mt-16 ${hasTextFeedback ? '' : 'text-secondary'}'>
            ${hasTextFeedback ? this.participant.feedback.textReview : t('No comment')}
          </p>
          ${this.showTransactionalBadge && this.participant.transactional ?
            html `<trust-transactional-badge classNames="mt-8"></trust-transactional-badge>` : nothing}
        </div>
        ${this.showReplies && ((_c = this.participant.reply) === null || _c === void 0 ? void 0 : _c.text) ? html `
          <div class="m-16" data-test="reply">
            <div class="flex flex-row">
              <img class="w-24 h-24 rounded-full" src="${this.participant.avatarUrl}" />
              <div class="mx-8 my-4">
                <div>
                  ${this.participant.reply.authorName} ${t('replied')}:
                </div>
                <div class="my-8">
                  ${(_e = (_d = this.participant) === null || _d === void 0 ? void 0 : _d.reply) === null || _e === void 0 ? void 0 : _e.text}
                </div>
                <div class="my-4 text-secondary">${formatDate(this.participant.reply.givenAt)}</div>
              </div>
            </div>
          </div>
        ` : nothing}
      </li>
    `;
    }
};
__decorate([
    property({ type: Object })
], PublicFeedback.prototype, "participant", void 0);
__decorate([
    property()
], PublicFeedback.prototype, "profileUrl", void 0);
__decorate([
    property({ type: Boolean })
], PublicFeedback.prototype, "noShadows", void 0);
__decorate([
    property({ type: Boolean })
], PublicFeedback.prototype, "showReplies", void 0);
__decorate([
    property({ type: Boolean })
], PublicFeedback.prototype, "showTransactionalBadge", void 0);
PublicFeedback = __decorate([
    customElement('trust-public-listing-feedback')
], PublicFeedback);
export { PublicFeedback };
//# sourceMappingURL=PublicFeedback.js.map